export const errorNotificationDuration = 5000;

export const ACTIVITY_TYPES = {
  LOGIN: 'login',
  WELCOME: 'welcome',
  POINTS_ON_ORDER_DELIVERY: 'points-on-order-delivery',
  PAY_BY_POINTS: 'pay-by-points',
  CURRENCY_TO_POINTS: 'currency-to-points'
};

export const ACTIVITY_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED'
};

export const UNPUBLISH_BUTTON_VISIBLE_STATUS = [
  ACTIVITY_STATUS.PUBLISHED,
  ACTIVITY_STATUS.ACTIVE
];

export const PUBLISH_BUTTON_VISIBLE_STATUS = [ACTIVITY_STATUS.DRAFT];

export const SURVEY_DUPLICATE_BUTTON_ENABLED_STATUS = [
  ACTIVITY_STATUS.PUBLISHED,
  ACTIVITY_STATUS.ACTIVE,
  ACTIVITY_STATUS.COMPLETED,
  ACTIVITY_STATUS.DRAFT
];

export const SURVEY_DOWNLOAD_BUTTON_DISABLED_STATUS = [
  ACTIVITY_STATUS.DRAFT,
  ACTIVITY_STATUS.PUBLISHED
];

export const WARNING_MESSAGE = {
  SCHEDULING_CONFLICT_DETECTED: 'Scheduling Conflict Detected'
};

export const LoginFormData = {
  activityType: ACTIVITY_TYPES.LOGIN,
  dailyLoginLimit: 0,
  allTimeLoginLimit: 0,
  frequency: '',
  pointsEarned: 0,
  activeStartDate: new Date(),
  activeEndDate: new Date(),
  isDraft: false
};

export const PointsOnOrderDeliveryFormData = {
  activityType: ACTIVITY_TYPES.POINTS_ON_ORDER_DELIVERY,
  activityName: '',
  selectedSegments: [],
  orderType: '',
  dollarSpend: '',
  pointsEarned: '',
  activeStartDate: new Date(),
  activeEndDate: new Date(),
  isDraft: false
};

export const WelcomeFormData = {
  activityType: ACTIVITY_TYPES.WELCOME,
  pointsEarned: '',
  activeStartDate: new Date(),
  activeEndDate: new Date(),
  hasEndDate: false,
  isDraft: false
};

export const PayByPointsOnOrderDeliveryFormData = {
  activityType: ACTIVITY_TYPES.PAY_BY_POINTS,
  activityName: '',
  pointsToRedeem: '',
  localCurrencyValue: '',
  startDate: null,
  endDate: null,
  hasEndDate: false,
  isDraft: false
};

export const FormErrors = {};

export const activityOptions = [
  {
    id: '1',
    type: ACTIVITY_TYPES.WELCOME,
    displayName: 'Welcome'
  },
  {
    id: '2',
    type: ACTIVITY_TYPES.LOGIN,
    displayName: 'Login'
  },
  {
    id: '3',
    type: ACTIVITY_TYPES.POINTS_ON_ORDER_DELIVERY,
    displayName: 'Points On Order Delivery'
  },
  {
    id: '4',
    type: ACTIVITY_TYPES.PAY_BY_POINTS,
    displayName: 'Pay by Points on Order Delivery'
  }
];

export const orderTypeOptions = [
  {
    id: '1',
    type: 'online',
    displayText: 'Online'
  },
  {
    id: '2',
    type: 'offline',
    displayText: 'Offline'
  },
  {
    id: '3',
    type: 'all',
    displayText: 'Online & Offline'
  }
];

export const OrderType = {
  Online: 'Online',
  Offline: 'Offline',
  Both: 'Both'
};

export const ACTIVITY_TYPES_ENUM = {
  WELCOME: 'WELCOME',
  LOGIN: 'LOGIN',
  PLAY_GAME: 'PLAY_GAME',
  WATCH_VIDEO: 'WATCH_VIDEO',
  SURVEY: 'SURVEY',
  POINTS_TRANSFER: 'POINTS_TRANSFER',
  POINTS_ON_ORDER_DELIVERY: 'PRODUCT_PURCHASE',
  REDEEM_POINTS: 'REDEEM_POINTS',
  GENERIC_ACTIVITY: 'GENERIC_ACTIVITY',
  POINT_EXPIRATION: 'POINTS_EXPIRY',
  PAY_BY_POINTS: 'PAY_BY_POINTS',
  CURRENCY_TO_POINTS: 'CURRENCY_TO_POINTS_CONVERSION'
};

export const ACTIVITY_TYPE = {
  WELCOME_ACTIVITY: 'Welcome Activity',
  LOGIN: 'Login',
  PLAY_GAME: 'Play Game',
  WATCH_VIDEO: 'Video',
  SURVEY: 'Survey',
  POINTS_TRANSFER: 'Points Transfer',
  POINTS_ON_ORDER_DELIVERY: 'Points On Order Delivery',
  REDEEM_POINTS: 'Redeem Points',
  GENERIC_ACTIVITY: 'Generic Activity',
  POINT_EXPIRATION: 'Points Expiration',
  PAY_BY_POINTS: 'Pay By Points',
  CURRENCY_TO_POINTS: 'Currency To Points Conversion'
};

export const ACTIVITY_TYPE_TO_VALUE = {
  'Welcome Activity': 'WELCOME',
  Login: 'LOGIN',
  'Points On Order Delivery': 'PRODUCT_PURCHASE',
  'Points Expiration': 'POINTS_EXPIRY',
  'Pay By Points': 'PAY_BY_POINTS',
  Survey: 'SURVEY',
  Video: 'WATCH_VIDEO',
  'Currency To Points Conversion': 'CURRENCY_TO_POINTS'
};

/** True when activity is watch-video. */
export const isVideoActivityType = (activityType) =>
  activityType === ACTIVITY_TYPE.WATCH_VIDEO ||
  activityType === ACTIVITY_TYPES_ENUM.WATCH_VIDEO;
